<template>
  <div class="forms-page">
    <button
      v-for="(form, idx) in forms"
      :key="idx"
      data-testid="forms-list"
      class="forms-list"
      aria-haspop="dialog"
      @click="$emit('open', form)"
      @keydown.enter="$emit('open-via-keyboard', form)"
    >
      <div
        :data-testid="`form-${form.id}`"
        class="form-choice"
      >
        <div class="form-name">
          {{ form.attributes.name }}
        </div>
        <img
          src="../../../../assets/right_arrow.svg"
          class="form-choice-icon"
          alt=""
        />
      </div>
    </button>
  </div>
</template>

<script>
import cssVars from '../components/mixins/color-vars';

export default {
  name: 'FormsList',
  mixins: [cssVars],
  props: {
    forms: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['open', 'open-via-keyboard'],
};
</script>

<style lang="scss" scoped>
.forms-list {
  box-sizing: border-box;
  margin: 10px auto 0;
  border: 1px solid #333;
  padding: 16px 24px;
  border-radius: 3px;
  cursor: pointer;
  max-width: 90%;
  width: 90%;
  background: none;
}
.form-choice {
  display: flex;
  justify-content: space-between;
  align-items: center;
  :focus {
    outline: none;
  }
}
.form-name {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
}
.form-choice-icon {
  width: 6px;
  height: 11px;
}
</style>
